import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {MAX_RECIPIENTS, normalizeSearch} from '../rulesModel';

/**
 * «A estas personas»: el roster de usuarios de la agencia (`options.users`). Sólo usuarios de la
 * agencia (D2): ni del portal ni correos externos. A quien no ve un cliente no le llega aunque esté
 * elegido: el backend resuelve los destinatarios al enviar.
 */
export function RecipientsPicker({userIds, options, onChange, max = MAX_RECIPIENTS}) {
    const {t} = useTranslation();
    const [query, setQuery] = useState('');
    const needle = normalizeSearch(query);
    const roster = (options && options.users) || [];
    const users = roster
        .filter((user) => !needle || normalizeSearch(`${user.name} ${user.email || ''}`).includes(needle));
    const atMax = userIds.length >= max;
    // Elegidos que ya no están en el roster (alguien que se fue): no se ven en la lista, se nombran.
    const gone = userIds.filter((id) => !roster.some((user) => user.id === id));

    const toggle = (id) => onChange(userIds.includes(id) ? userIds.filter((item) => item !== id) : [...userIds, id]);

    return (
        <div className="alc-pick">
            <input type="search" className="alc-pick__search" data-autofocus value={query}
                   placeholder={t('alerts_center.builder.pick_search_people')}
                   aria-label={t('alerts_center.builder.pick_search_people')}
                   onChange={(event) => setQuery(event.target.value)}/>
            <div className="alc-pick__scroll">
                {users.length === 0 && <p className="alc-pick__empty">{t('alerts_center.builder.pick_none')}</p>}
                <ul className="alc-pick__list">
                    {users.map((user) => {
                        const checked = userIds.includes(user.id);
                        const inputId = `alc-recipient-${user.id}`;
                        return (
                            <li key={user.id} className="alc-pick__item">
                                <input id={inputId} type="checkbox" checked={checked} disabled={!checked && atMax}
                                       onChange={() => toggle(user.id)}/>
                                <label htmlFor={inputId}>
                                    <span className="alc-pick__name">{user.name}</span>
                                    {user.email && <span className="alc-pick__extra">{user.email}</span>}
                                </label>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {gone.length > 0 && (
                <div className="alc-pick__stale" data-testid="alc-pick-gone">
                    <span>{t('alerts_center.builder.pick_gone', {count: gone.length})}</span>
                    <button type="button" className="alc-link -button"
                            onClick={() => onChange(userIds.filter((id) => !gone.includes(id)))}>
                        {t('alerts_center.builder.pick_stale_remove')}
                    </button>
                </div>
            )}
            <div className="alc-pick__foot">
                <span>{t('alerts_center.builder.picked', {count: userIds.length, max})}</span>
            </div>
        </div>
    );
}
